var _effectorFileName = "/builds/gmini/front-utils/src/subscriptionsPull.ts";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
export function subscriptionsPull() {
  for (var _len = arguments.length, subscriptions = new Array(_len), _key = 0; _key < _len; _key++) {
    subscriptions[_key] = arguments[_key];
  }

  var unsubscribe = function unsubscribe() {
    return subscriptions.forEach(function (subscription) {
      return subscription.unsubscribe();
    });
  };

  unsubscribe.unsubscribe = unsubscribe;
  return unsubscribe;
}